<template>
  <div class="app-container">
    <el-form
      :model="noteForm"
      ref="noteForm"
      :rules="rules"
      label-width="120px"
      class="demo-ruleForm"
      size="medium"
    >
      <el-form-item label="accessKeyId" prop="oss_accessKeyId">
        <el-input
          v-model="noteForm.oss_accessKeyId"
          :disabled="cztype == 'see'"
          placeholder="请输入accessKeyId"
        ></el-input>
      </el-form-item>
      <el-form-item label="accessKeySecret" prop="oss_accessKeySecret">
        <el-input
          v-model="noteForm.oss_accessKeySecret"
          :disabled="cztype == 'see'"
          placeholder="请输入accessKeySecret"
        ></el-input>
      </el-form-item>
      <el-form-item label="短信模版" prop="oss_template">
        <el-input
          v-model="noteForm.oss_template"
          :disabled="cztype == 'see'"
          placeholder="请输入短信模版"
        ></el-input>
      </el-form-item>
      <el-form-item label="短信签名" prop="oss_sign">
        <el-input
          v-model="noteForm.oss_sign"
          :disabled="cztype == 'see'"
          placeholder="请输入短信签名"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="cztype == 'edit'">
        <el-button
          type="primary"
          @click="edit()"
          v-if="roles.includes('/conf/set_message')"
        >
          立即修改
        </el-button>
        <el-button type="info" @click="getInfo()"> 取消 </el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button type="success" @click="cztype = 'edit'"> 修改 </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getMeconf, setMessage } from "@/api/conf";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  data() {
    return {
      noteForm: {},
      cztype: "see",
      rules: {
        oss_accessKeyId: [
          { required: true, message: "请输入accessKeyId", trigger: "blur" },
        ],
        oss_accessKeySecret: [
          { required: true, message: "请输入accessKeySecret", trigger: "blur" },
        ],
        oss_template: [
          { required: true, message: "请输入短信模版	", trigger: "blur" },
        ],
        oss_sign: [
          { required: true, message: "请输入短信签名", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    edit() {
      var that = this;
      setMessage(this.noteForm).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          that.getInfo();
        }
      });
    },
    // LTAI5tBLribUTNddK3dcHEmf
    getInfo() {
      getMeconf().then((res) => {
        this.noteForm = {
          oss_accessKeyId: res.data.oss_accessKeyId,
          oss_accessKeySecret: res.data.oss_accessKeySecret,
          oss_sign: res.data.oss_sign,
          oss_template: res.data.oss_template,
        };
        this.cztype = "see";
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  padding: 60px;
}
</style>
